import { useState } from 'react';
import CloudIcon from '@mui/icons-material/Cloud';

import Spotify from './components/spotify/Spotify';
import Weather from './components/weather/Weather';
import api from './api/api';

import clear from './images/clear.gif';
import cloud from './images/cloud.gif';
import rain from './images/rain.gif';
import snow from './images/snow.gif';
import mist from './images/mist.gif';

import './App.css';

const App = () => {
    const [backgroundImg, setBackgroundImg] = useState<any>();
    const [token, setToken] = useState('');
    const [url, setUrl] = useState('');

    const setWeatherImg = (weather: string) => {
        let img = '';
        let playlist = '';

        switch(weather) {
            case 'Clouds':
                img = cloud;
                playlist = 'cloudy day';
                break;
            case 'Rain':
                img = rain;
                playlist = 'rainy day';
                break;
            case 'Snow':
                img = snow;
                playlist = 'snowy day';
                break;
            case 'Mist':
                img = mist;
                playlist = 'misty day';
                break;
            case 'Sun':
            default:
                img = clear;
                playlist = 'sunny day';
        }

        setBackgroundImg(img);
        getPlaylist(playlist);
    }

    const setUserToken = (token: string) => {
        setToken(token);
    }

    const getPlaylist = (searchTerm: string) => {
        console.log("hey man", token)
        api.getPlaylist(searchTerm, token)
            .then(data => {
                const numberOfPlaylists = data.playlists.items.length;
                const randomIndex = Math.floor(Math.random() * numberOfPlaylists)
                let externalUrl = data.playlists.items[randomIndex].external_urls.spotify;

                // https://open.spotify.com/embed?uri=spotify:album:1DFixLWuPkv3KT3TnV35m3
                // <iframe style="border-radius:12px" src="https://open.spotify.com/embed/playlist/031QvXHmfmpAOocj2ZFwP4?utm_source=generator" width="100%" height="380" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"></iframe>
                // https://open.spotify.com/playlist/37i9dQZF1EIhkGftn1D0Mh
                if(externalUrl) {
                    const formattedUrl = externalUrl.replace('/playlist/', '/embed/playlist/');
                    setUrl('https://open.spotify.com/embed?uri=spotify:playlist:37i9dQZF1EIhkGftn1D0Mh');
                    console.log("iframe url", formattedUrl, url)
                }
            })
            .catch(err => {
                console.error("error", err)
            })
    }

    return (
        <div className='app' style={{ backgroundImage: `url(${backgroundImg})`,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover'
        }}>
            <div className='container'>
                <h1 className='main-header'>
                    Weather<span className='main-header-accent'>fy</span>
                </h1>
                <Spotify setUserToken={setUserToken} />
                {token && <Weather setWeatherImg={setWeatherImg} />}
                {token && url &&
                    <iframe
                        className='iframe'
                        src={url}
                        frameBorder="0"
                        allow="encrypted-media"
                        loading="lazy">
                    </iframe>
                }
                {token && !url &&
                    <div className='empty-frame'>
                        <div><CloudIcon className='cloud-icon' /></div>
                        <p>It's quiet in here...</p>
                    </div>
                }
                <div className='footer'>Made by <a href='https://tyypos.com' target='_blank' className='link'>Tyypos</a></div>
            </div>
        </div>
    );
}

export default App;
